import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { requestTypesData, } from './requestTypeActions'
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";

type RequestTypeState = {
  dataRequestTypes: {
    payload: RequestTypeResponse[] | null,
    payload_update: RequestTypeResponse | null,
    loading: boolean,
    success: boolean,
    error: string | null;
  }
}

const initialState:  RequestTypeState= {
  dataRequestTypes: {
    loading: false,
    success: false,
    payload_update: null,
    payload: [],
    error: "",
  }
}

export type RequestTypeResponse = {
  id: number,
  title: string,
  project_code: string,
}

const requestTypesReducer = createSlice({
  name: 'requesttype',
  initialState: initialState,
  reducers: {

    // Обычные редьюсеры
    setClientsState(state, action: PayloadAction<RequestTypeResponse[]>) {
      state.dataRequestTypes.payload = [];
      state.dataRequestTypes.payload = action.payload;
    },

    setClientUpdateState(state, action: PayloadAction<RequestTypeResponse>) {
      state.dataRequestTypes.payload_update = null;
      state.dataRequestTypes.payload_update = action.payload;
      //console.log(state.dataRequestTypes.payload_update)

    }

  },

  extraReducers: (builder) => {
    builder
      .addCase(requestTypesData.pending, (state) => {
        state.dataRequestTypes.loading = true;
        state.dataRequestTypes.error = null;
      })
      .addCase(requestTypesData.fulfilled, (state, action) => {
        state.dataRequestTypes.loading = false;
        requestTypesReducer.caseReducers.setClientsState(state, action);
      })
      .addCase(requestTypesData.rejected, (state, action) => {
        state.dataRequestTypes.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataRequestTypes.error = errorText ? errorText : "";
      })

  }

})

const getErrorText = (error: ErrorResponse) => {

 // console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
}


export default requestTypesReducer.reducer